import axios from 'axios';

interface ApiErrorShape {
  code?: string;
  message?: string;
  field?: string;
}

export function parseApiError(error: unknown): {
  message: string;
  code: string;
  fields: string[];
} {
  if (axios.isAxiosError(error)) {
    if (!error.response) {
      return {
        message: error.message || 'Network error. Please check your connection.',
        code: 'NETWORK_ERROR',
        fields: [],
      };
    }

    const errors = (error.response.data as { errors?: ApiErrorShape[] } | undefined)?.errors ?? [];
    const first = errors[0];
    const fields = errors
      .map((entry) => entry.field)
      .filter((field): field is string => Boolean(field));

    return {
      message: first?.message ?? error.response.statusText ?? 'Request failed',
      code: first?.code ?? String(error.response.status),
      fields,
    };
  }

  if (error instanceof Error) {
    return { message: error.message, code: 'ERROR', fields: [] };
  }

  return { message: 'Something went wrong', code: 'UNKNOWN_ERROR', fields: [] };
}

export function getValidationMessage(error: unknown): string {
  const parsed = parseApiError(error);
  if (parsed.fields.length > 0) {
    return `Please fill in: ${parsed.fields.join(', ')}`;
  }
  return parsed.message;
}
